import { Account } from '@air/api';
import { Airror, matchesAirror, WORKSPACE_INTEGRATION_SSO_NOT_ENABLED } from '@air/errors';

export const getIsSAMLEnforced = async (email: string) => {
  try {
    const ssoOptions = await Account.getAccountSSOOptionsV2({ email });

    if (isAirrorInstance(ssoOptions)) {
      throw ssoOptions;
    }

    return ssoOptions.data.length > 0
      ? !!ssoOptions.data.find((ssoOption) => !!ssoOption.enforce && !!ssoOption.isMember)
      : false;
  } catch (error) {
    if (matchesAirror(error, WORKSPACE_INTEGRATION_SSO_NOT_ENABLED)) {
      return false;
    } else {
      throw error;
    }
  }
};

// https://linear.app/air/issue/ENG-135/update-isairrorinstance-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isAirrorInstance(result: unknown): result is Airror<any> {
  return result instanceof Airror;
}
